var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface2758733"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(78.431373%,81.960784%,85.882353%)",
      fillOpacity: 1
    },
    d: "M 0.625 0.625 L 29.375 0.625 L 29.375 29.375 L 0.625 29.375 Z M 0.625 0.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40%,47.45098%,56.078431%)",
      fillOpacity: 1
    },
    d: "M 28.800781 1.199219 L 28.800781 28.800781 L 1.199219 28.800781 L 1.199219 1.199219 L 28.800781 1.199219 M 29.949219 0.0507812 L 0.0507812 0.0507812 L 0.0507812 29.949219 L 29.949219 29.949219 Z M 29.949219 0.0507812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.550781 5.800781 L 26.5 5.800781 L 26.5 9.25 L 11.550781 9.25 Z M 11.550781 5.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.058824%,54.509804%,61.176471%)",
      fillOpacity: 1
    },
    d: "M 3.5 6.949219 L 9.25 6.949219 L 9.25 8.101562 L 3.5 8.101562 Z M 3.5 6.949219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.550781 12.699219 L 26.5 12.699219 L 26.5 16.148438 L 11.550781 16.148438 Z M 11.550781 12.699219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(47.058824%,54.509804%,61.176471%)",
      fillOpacity: 1
    },
    d: "M 3.5 13.851562 L 9.25 13.851562 L 9.25 15 L 3.5 15 Z M 3.5 13.851562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(54.509804%,71.764706%,94.117647%)",
      fillOpacity: 1
    },
    d: "M 12.125 21.324219 L 25.925781 21.324219 L 25.925781 24.773438 L 12.125 24.773438 Z M 12.125 21.324219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(30.588235%,47.843137%,70.980392%)",
      fillOpacity: 1
    },
    d: "M 25.351562 21.898438 L 25.351562 24.199219 L 12.699219 24.199219 L 12.699219 21.898438 L 25.351562 21.898438 M 26.5 20.75 L 11.550781 20.75 L 11.550781 25.351562 L 26.5 25.351562 Z M 26.5 20.75 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.568d8330.svg";
export { ForwardRef as ReactComponent };